module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_8017.02ae7e25.png";